import { useFeatureFlagEnabled } from "@posthog/react";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useRole } from "@/hooks/use-role";
import { PermissionDeniedPage } from "@/components/team/PermissionDeniedPage";
import { useEffect } from "react";
import { useSession } from "@/hooks/use-session";
import { SignupFormEditor } from "@/components/signup-forms/SignupFormEditor";

export const Route = createFileRoute("/_app/_/forms/new")({
	component: NewFormPage,
});

function NewFormPage() {
	const session = useSession();
	const { isReadWrite } = useRole();
	const navigate = useNavigate();
	const campaignId = session.campaign?.id;
	const flagEnabled = useFeatureFlagEnabled("signup-forms");

	useEffect(() => {
		if (flagEnabled === false) {
			navigate({ to: "/", search: {} as never });
		}
	}, [flagEnabled, navigate]);

	if (flagEnabled !== true) return null;
	if (!isReadWrite) {
		return (
			<PermissionDeniedPage requiredRole="Read/Write" message="You need Read/Write or Admin access to create a form." />
		);
	}

	if (!campaignId) {
		return (
			<div className="p-6 text-muted-foreground">
				No campaign selected.
			</div>
		);
	}

	return (
		<div className="p-6">
			<SignupFormEditor campaignId={campaignId} />
		</div>
	);
}
